'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Card } from '@components/card';
import { memo } from 'react';

import { useGetClientHost } from '@/shared/hooks';
import type { Domain } from '@/shared/types';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

const classes: Record<number, string> = {
  0: 'h-auto max-w-[295px] min-[1100px]:mt-[2px] min-[1100px]:ml-[20px]',
  1: 'row-span-2 w-full max-w-[573px] min-[1100px]:mt-[3px]',
  2: 'h-auto w-[463px] min-[1100px]:mt-[38px] min-[1100px]:ml-[29px]',
};

export const DeviceSupportSectionClient = memo(
  ({ imagesByDomain }: { imagesByDomain: Record<Domain, AppImageData[]> }) => {
    const domain = getDomainKey(useGetClientHost());
    const images = imagesByDomain[domain];

    if (!images) {
      return null;
    }

    return (
      <Card>
        <div className="grid h-[471px] grid-cols-2 grid-rows-2 rounded-[20px] p-6 max-[1100px]:flex max-[1100px]:h-auto max-[1100px]:flex-col max-[1100px]:items-center max-[1100px]:gap-6">
          {images.map((imageData, order) => (
            <AppImageClient
              key={order}
              {...imageData}
              alt=""
              className={classes[order]}
            />
          ))}
        </div>
      </Card>
    );
  },
);

DeviceSupportSectionClient.displayName = 'DeviceSupportSectionClient';
